import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { staggeredBaseQuery } from "./staggeredBaseQuery";
import { TrainingLocation, Training } from "../../common/Training";

export const trainingApi = createApi({
    reducerPath: "trainingApi",
    tagTypes: ["Training"],
    baseQuery: staggeredBaseQuery(""),
    endpoints: (builder) => ({
        getTrainings: builder.query<Training[], boolean | void>({
            query: (includeDeleted) => {
                return {
                    method: "GET",
                    url: `training${includeDeleted ? '?includeDeleted=true' : ''}`,
                };
            },
        }),
        getTrainingLocations: builder.query<TrainingLocation[], void>({
            query: () => {
                return {
                    method: "GET",
                    url: "training/locations",
                };
            },
        }),
        createTraining: builder.mutation<Training, Partial<Training>>({
            query: (training) => {
                return {
                    method: "POST",
                    url: "training",
                    body: training,
                };
            },
            invalidatesTags: [{ type: "Training", id: "LIST" }],
        }),
        editTraining: builder.mutation<Training, { trainingId: number, training: Training }>({
            query: ({ trainingId, training }) => {
                return {
                    method: "PUT",
                    url: `training/${trainingId}`,
                    body: training,
                }
            }
        }),
        createTrainingLocation: builder.mutation<TrainingLocation, string>({
            query: (location) => {
                return {
                    method: "POST",
                    url: "training/location",
                    body: location,
                };
            },
            invalidatesTags: [{ type: "Training", id: "LIST" }],
        }),
        deleteTraining: builder.mutation<boolean, number> ({
            query: (id) => {
                return {
                    method: "DELETE",
                    url: `training/${id}`,
                }
            }
        }),
        restoreTraining: builder.mutation<boolean, number> ({
            query: (id) => {
                return {
                    method: "PATCH",
                    url: `training/${id}/restore`,
                }
            }
        }),
        deleteTrainingLocation: builder.mutation<boolean, String>({
            query: (location) => {
                return {
                    method: "DELETE",
                    url: "training/location",
                    body: location
                }
            }
        }),
    }),
});

export const {
    useGetTrainingsQuery,
    useGetTrainingLocationsQuery,
    useCreateTrainingMutation,
    useCreateTrainingLocationMutation,
    useEditTrainingMutation,
    useDeleteTrainingMutation,
    useDeleteTrainingLocationMutation,
    useRestoreTrainingMutation,
} = trainingApi;